import { ScoreboardDataRef } from '../Liveboard.service'
import { get } from 'lodash'
import moment from 'moment'

export const getScoreCard = async (
  item: any,
  datePicked: moment.Moment[],
  data: any,
  tenantKey: string
) => {
  const result = await ScoreboardDataRef(item, datePicked, data, tenantKey)

  const scoreIndex = result.cols.findIndex(
    (cols) => cols.name === item?.configure?.chart_value[0]
  )
  const percentageIndex = result.cols.findIndex(
    (cols) => cols.name === 'up_down_percentage'
  )
  if (scoreIndex !== -1) {
    if (percentageIndex !== -1) {
      return {
        score: get(result, 'rows[0][' + scoreIndex + ']', 0),
        percentage: get(result, 'rows[0][' + percentageIndex + ']', null),
      }
    } else
      return {
        score: get(result, 'rows[0][' + scoreIndex + ']', 0),
        percentage: get(result, 'rows[0][1]', null),
      }
  }
  return {
    score: get(result, 'rows[0][0]', 0),
    percentage: get(result, 'rows[0][1]', null),
  }
}
